import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import z from 'zod'

interface SetPasswordFormType {
  newPassword: string
  passwordConfirm: string
}

const schema = z.object({
  newPassword: z.string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number'),
  passwordConfirm: z.string(),
}).superRefine((data, ctx) => {
  if (data.newPassword !== data.passwordConfirm) {
    ctx.addIssue({
      code: 'custom',
      path: ['passwordConfirm'],
      message: 'Passwords do not match',
    })
  }
})

export default function useSetPasswordForm() {
  return useForm<SetPasswordFormType>({
    resolver: zodResolver(schema),
    defaultValues: {
      newPassword: '',
      passwordConfirm: '',
    },
  })
}
